import React, { createContext, useContext } from 'react';

import VistaprintAuth from '@vp/auth';
import { useIdentity } from '@vp/ubik-context';

interface IAuthContext {
  isInitialized: boolean;
  authorizationHeader?: string;
  shopperId?: string;
  token?: string;
}

const defaultAuthContext: IAuthContext = {
  isInitialized: false,
};

const AuthContext = createContext<IAuthContext>(defaultAuthContext);

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const { auth } = useIdentity();

  return <AuthContext.Provider value={calculateAuthContext(auth)}>{children}</AuthContext.Provider>;
};

function calculateAuthContext(auth: VistaprintAuth | undefined): IAuthContext {
  return {
    isInitialized: !!auth,
    authorizationHeader: auth?.getAuthorizationHeader(),
    shopperId: auth?.getCanonicalId?.(),
    token: auth?.getToken?.(),
  };
}

export const useAuthContext = () => useContext(AuthContext);
